// NOTE: doctor finder CSS is NOT imported here. A JS-side SCSS import would
// compile as an isolated unit with no theme-variable preamble, so all the
// per-PD sparkle_themes overrides fall back to their `!default` values and
// you get 1020px max-width, 5px toggle radius, 56px heading, square corners,
// etc. Instead, `doctor_finder/index` is appended to every themed Vite
// entrypoint by `lib/tasks/sparkle/vite_themes.rake` — see the TRANSITIONAL
// comment there for the full rationale and the link to the follow-up ticket
// (#25818) that lets us delete both of these comments.

import "#/legacy/namespaces.js";

// IMPORTANT: doctor_finder.js MUST load before the model/collection/helper/view
// globs below. It defines `window.DoctorFinder` as a class and calls
// `initClass()` which initializes `DoctorFinder.Models`, `.Views`, `.Collections`.
// Sub-files in models/, collections/, etc. then attach to those namespaces.
// Reordering them changes the load order from Sprockets' alphabetical require_tree
// (where doctor_finder.js loaded first) and would otherwise blow away their entries.
import "./doctor_finder.js";
import.meta.glob("./models/**/*.{js,hbs,jst.ejs,jst.ejs.erb}", { eager: true });
import.meta.glob("./collections/**/*.{js,hbs,jst.ejs,jst.ejs.erb}", { eager: true });
import.meta.glob("./templates/**/*.{js,hbs,jst.ejs,jst.ejs.erb}", { eager: true });
import.meta.glob("./helpers/**/*.{js,hbs,jst.ejs,jst.ejs.erb}", { eager: true });
import.meta.glob("./views/*.{js,hbs,jst.ejs,jst.ejs.erb}", { eager: true });
import "virtual:client-templates/lib/sparkle/doctor_finder_v3/app/assets/javascripts/physician_finder/templates";

jQuery(document).on("click", "[data-behaviour~=submit]", function (event) {
  event.preventDefault();
  jQuery(this).closest("form").trigger("submit");
});

if ("geolocation" in navigator) {
  jQuery(document).on("click", "[data-behaviour~=geolocate]", function (event) {
    event.preventDefault();
    var element = jQuery(this);

    element.trigger("geolocating");

    navigator.geolocation.getCurrentPosition(
      function (location) {
        // var location = { coords: { latitude: '13', longitude: '12' } } // DEBUG: For local testing where browsers refuse to geolocate on HTTP
        element.trigger("geolocated", [location]);
      },
      function (error) {
        element.trigger("geolocation-error");
      },
    );
  });
} else {
  jQuery("[data-behaviour~=geolocate]").addClass("hidden");
}
